import React from 'react';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { blackText, blueGrayText } from '../../constants/Colors';
import {
  cardContentPadding,
  cardSize,
  titleFontSize,
  titleMb
} from '../../constants/Location';

interface Props {
  icon: JSX.Element;
  text: string;
  description: string;
  descFontSize?: string;
  button: JSX.Element;
  center?: boolean;
}

const styles = {
  cardContentPadding,
  cardSize,
  discription: {
    color: blueGrayText,
    marginBottom: '32px',
    whiteSpace: 'pre-wrap'
  },
  text: {
    '@media screen and (max-width:480px)': {
      marginBottom: '16px'
    },
    color: blackText,
    fontSize: titleFontSize,
    marginBottom: '24px',
    whiteSpace: 'pre-wrap'
  },
  titleMb
};

const CompleteCard: React.FC<Props> = (props) => {
  const { icon, text, description, button, descFontSize, center } = props;

  const descFont = (): object =>
    descFontSize ? { fontSize: descFontSize } : { fontSize: '12px' };

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid item xs={12}>
        <Card sx={styles.cardSize}>
          <CardContent
            sx={[styles.cardContentPadding, { paddingBottom: '40px' }]}
          >
            <Typography component="div" align="center">
              {icon}
            </Typography>
            <Typography sx={styles.text} component="div" align="center">
              {text}
            </Typography>
            <Typography
              sx={[
                styles.discription,
                descFont(),
                { textAlign: center ? 'center' : 'left' }
              ]}
              component="div"
            >
              {description}
            </Typography>
            {button}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CompleteCard;
